const images={
    cpp: require('./C++.png').default,
    css: require('./Css.png').default,
    html: require('./Html5.png').default,
    java: require('./Java.png').default,
    js: require('./Javascript.png').default,
    matlab: require('./Matlab.svg').default,
    python: require('./Python.png').default,
    react: require('./React.png').default,
    sql: require('./Sql.png').default,
    vhdl: require('./Vhdl.png').default,
    github: require('./Github.png').default,
    hw: require('./HeavenlyWriting.png').default,
    tt: require('./Trailtracker.png').default,
    pw: require('./PortfolioWebsite.png').default,
    rc: require('./RoboCode.png').default,
    cc: require('./CryptoCup.png').default,
}


export default images;